module.exports = __webpack_public_path__ + "static/img/loading.0f91f949.gif";